import authenticationSettings from "../../../site/configuration/AuthenticationSettings";
import { Navigate, useLocation, useNavigate } from "react-router";
import { useUserInfo } from "../../hooks/useUserInfo";
import React, { useEffect, useState } from "react";
import ServiceProvider from "../../../site/configuration/ServiceProvider";
import {
  Auth0Provider,
  useAuth0,
  withAuthenticationRequired,
} from "@auth0/auth0-react";
import { setOidcAccessToken } from "../../helpers/OidcAccessTokenHelper";
import AuthenticationLoading from "../../../site/components/Authentication/AuthenticationLoading";
import AuthenticationRedirecting from "../../../site/components/Authentication/AuthenticationRedirecting";
import AuthenticationError from "../../../site/components/Authentication/AuthenticationError";

export const Auth0Authentication: React.FC<React.PropsWithChildren<any>> = (
  props: React.PropsWithChildren<any>
) => {

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(()=>{
    // questo non serve piu' xche' abbiamo aggiunto onRedirectCallback
    const returnUrl = sessionStorage.getItem("returnlUrl");
    if (!returnUrl) {
      sessionStorage.setItem("returnlUrl", location.pathname + location.search);
    }
  }, []);

  const hostName = window.location.hostname;

  return authenticationSettings.authenticationEnabled ? (
    <Auth0Provider
      domain={authenticationSettings.oidcConfig.authority!}
      clientId={authenticationSettings.oidcConfig.client_id!}
      authorizationParams={{
        redirect_uri: authenticationSettings.oidcConfig.redirect_uri?.replace("-hostName-", hostName),
        audience: authenticationSettings.oidcConfig.audience,
        scope: "openid profile email offline_access",
      }}
      onRedirectCallback={(appState) => {
        navigate(appState?.returnTo || window.location.pathname);
      }}
    >
      <AuthenticationSwitch>{props.children}</AuthenticationSwitch>
    </Auth0Provider>
  ) : (
    <UserInfoProvider>{props.children}</UserInfoProvider>
  );
};

const AuthenticationSwitch: React.FC<any> = withAuthenticationRequired<
  React.PropsWithChildren<any>
>(
  (props: React.PropsWithChildren<any>) => {
    let { isAuthenticated, getAccessTokenSilently, isLoading, error } =
      useAuth0();
    const [accessToken, setAccessToken] = useState<string>();
  
    useEffect(() => {
      if (isAuthenticated) {
        getAccessTokenSilently().then((access_token) => {
          setOidcAccessToken(access_token);
          setAccessToken(access_token);
        });
      }
    }, [getAccessTokenSilently, isAuthenticated]);

    // ====== per stylare ====
    //error = { name: "", message: "si è verificato un problema" };
    // isLoading = true;
    const redirecting = false;

    if (error) {
      return <AuthenticationError error={{message:{title: "" + error}}}></AuthenticationError>;
    }
    //=======================================
    
    if (isLoading || !accessToken) {
      return <AuthenticationLoading />;
    }

    if (redirecting) {
      return <AuthenticationRedirecting />;
    }

    return <UserInfoProvider>{props.children}</UserInfoProvider>;
  },
  {
    onRedirecting: () => <AuthenticationRedirecting />,
  }
);

const UserInfoProvider: React.FC<React.PropsWithChildren<any>> = (
  props: React.PropsWithChildren<any>
) => {
  const [userInfo, setUserInfo] = useUserInfo();
  const isLoading = React.useRef<boolean>(false);
  const [userError, setUserError] = React.useState<{title: string}>();

  React.useEffect(() => {
    if (!isLoading.current) {
      ServiceProvider.System.getUserInfo()
        .then((result) => {
          setUserInfo(result);
          //isLoading.current = false;
        })
        .catch((e) => {
          setUserError(e.data);
        });
    }
    isLoading.current = true;
  }, []);

  if (userError) {
    return (
      <AuthenticationError error={{ message: userError }}></AuthenticationError>
    );
  } else if (!userInfo.userName) {
    return <AuthenticationLoading />;
  } else {
    return <>{props.children}</>;
  }
};
